import { Injectable, Inject, PLATFORM_ID, InjectionToken } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { init as fsInit, FullStory } from '@fullstory/browser';
import { User } from './user.service';

export interface FullStoryClient {
  init: (config: { orgId: string }) => void;
  FullStory: (command: string, payload: any) => void;
}

export const FULLSTORY_CLIENT = new InjectionToken<FullStoryClient>('FULLSTORY_CLIENT', {
  providedIn: 'root',
  factory: () => ({
    init: fsInit,
    FullStory: FullStory,
  }),
});


@Injectable({ providedIn: 'root' })
export class FullstoryService {
  private inited = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(FULLSTORY_CLIENT) private fsClient: FullStoryClient,
  ) {}

  init(): void {
    if (this.inited || !isPlatformBrowser(this.platformId)) return;

    this.fsClient.init({ orgId: 'o-19HDEM-na1' });
    this.inited = true;
  }

  setUser(user: User, org: string): void {
    this.fsClient.FullStory('setIdentity', {
      uid: user.id,
      properties: {
        displayName: user.name,
        email: user.email,
        organization: org,
        role: user.role
      }
    })
  }

  trackEvent(name: string, props?: Record<string, any>) {
    this.fsClient.FullStory('trackEvent', { name, properties: props });
  }

  trackCustomPage(pageName: string, props: Record<string, any>) {
    this.fsClient.FullStory('setProperties', {
      type: 'page',
      properties: {
        pageName: pageName,
        ...props
      }
    });
  }
}
